<form class="timeline" [formGroup]="form">
  <div class="timeline-author" [matTooltip]="timeline().author">
    {{ timeline().name }}
  </div>

  <div class="timeline-details">
    <div class="timeline-header">
      <div *ngIf="created()" class="timeline-createdon">
        Created on: {{ created() | date: "dd MMMM yyyy HH:mm:ss" }}
      </div>
  
      <div class="timeline-user">Created by: {{ timeline().author }}</div>

      <div class="timeline-controls">
        @if (canEditOrDelete()) {
          <button class="btn-delete" mat-icon-button (click)="edit.emit()">
            <mat-icon class="icon-delete">
              edit
            </mat-icon>
          </button>
 
          <button class="btn-delete" mat-icon-button (click)="delete.emit()">
            <mat-icon class="icon-delete" svgIcon="trash-can" />
          </button>
        }
      </div>
    </div>

    <div class="timeline-info">
      @if (timeline().state; as state) {
        <div class="timeline-state">{{ state | appApprovalState }}</div>
      }
    </div>

    <div class="timeline-title">
      @switch (timeline().type) {
        @case (TimelineItemType.Note) {
          <mat-icon class="icon"> edit_note </mat-icon>
        }
        @case (TimelineItemType.Notification) {
          <div class="email">
            <mat-icon class="icon"> mail </mat-icon> 
            <!-- Active -->
            {{ EMAIL }}
            <div class="timeline-state" [style.marginLeft.px]="8">{{ timeline().isProcessed ? 'Closed' : 'Active' }}</div>
          </div>
        }
        @case (TimelineItemType.StatusChangeComment) {
          <mat-icon class="icon"> error_outline </mat-icon>
        }
      }
      
      <h6 class="header">{{ timeline().title }}</h6>
    </div>

    <div class="timeline-attachments">
      @for (file of timeline().attachments; track $index) {
        <div class="timeline-attachments__item" (click)="download.emit(file.blobName)">
          <mat-icon>file_present</mat-icon>
          <a class="link">{{ file.fileName }}</a>
        </div>
      }
    </div>

    @if (isExpanded) {
      @if (timeline().recipients?.length) {
        <span class="chip-header">Recipients</span>
        <mat-chip-set class="chip-list" aria-label="Dog selection">
          @for (recipient of timeline().recipients; track $index) {
            <mat-chip class="chip">
              <!-- <mat-icon>account_circle</mat-icon> -->
              {{ recipient }}
            </mat-chip>
          }
        </mat-chip-set>
      }

      <div class="timeline-preview" [innerHTML]="timeline().previewText | formatText"></div>
    }

    @if (timeline().recipients || timeline().previewText) {
      <div class="timeline-toggle" (click)="isExpanded = !isExpanded">
        View {{ isExpanded ? "less" : "more" }}
      </div>
    }
  </div>
</form>
